import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import * as bootstrap from "bootstrap"
import "~/stylesheets/application.scss"

// Make Bootstrap available globally
window.bootstrap = bootstrap

Rails.start()
Turbolinks.start()
ActiveStorage.start()
